/* Wait for inputted "sec"*/
export async function sleep(sec: number): Promise<void> {
    await new Promise<void>(resolve => setTimeout(resolve, sec * 1000))
}

export function adminCheck(email: any) {
    if (
        email == 'sherry@akacorp.jp' ||
        email == 'onion+1@akaai.kr' ||
        email == 'support@akaintelligence.com' ||
        email == 'abc@aka.com'
    )
        return true
    else return false
}
